jQuery(function ($) {
  function closeItem($item) {
    $item.find('.faq__header').attr('aria-expanded', 'false');
    $item.find('.faq__panel').prop('hidden', true).stop(true, true).slideUp(160, function () {
      $(this).css('display', '');
    });
    $item.removeClass('is-open');
  }

  function openItem($item) {
    $item.find('.faq__header').attr('aria-expanded', 'true');
    $item.find('.faq__panel').prop('hidden', false).hide().stop(true, true).slideDown(200, function () {
      $(this).css('display', '');
    });
    $item.addClass('is-open');
  }

  $(document).on('click', '.block-faq .faq__header', function () {
    const $btn  = $(this);
    const $item = $btn.closest('.faq__item');
    const $list = $btn.closest('.faq__list');

    // Close siblings
    $list.find('.faq__item.is-open').not($item).each(function () {
      closeItem($(this));
    });

    if ($item.hasClass('is-open')) {
      closeItem($item);
    } else {
      openItem($item);
    }
  });
});
